export default __webpack_public_path__ + "static/media/shirtly_ipad_2.30a76b10.png";